module.exports = __webpack_public_path__ + "media/images/pc/stores/yokohama/yokohama_concept_03-e0c01effbdf28f394b827640ef8b1204.jpg";